import React from "react";
const CustomerInvoicePayment = () => {
  return (
    <>
      <span>Invoice payment</span>
    </>
  );
};
export default CustomerInvoicePayment;
